
document.addEventListener('DOMContentLoaded', () => {
    const images = document.querySelectorAll('.zoom-image');
    
    // Create Intersection Observer
  if(images.length > 0){
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate');
                // Optional: Stop observing after animation
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.3 // Trigger when 30% of section is visible
    });

    // Observe each image
    images.forEach(image => {
        // Reset animation class on each load
        image.classList.remove('animate');
        observer.observe(image);
    });
  }
});
  